import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface PaintingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Painting: React.FC<PaintingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [painting, set_painting] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Painting'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Painting': v } } })
    );
    const label = 'Painting';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(painting)}
                />
            ) : (
                <MoneyBox
                    id={'painting'}
                    allowNegative={false}
                    value={painting}
                    onChange={(value) => set_painting(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
